import React from "react";
import { SVGIconProps } from "./../type";

export default function PieChartIcon({ style, className }: SVGIconProps) {
  return (
    <svg
      x="0"
      y="0"
      version="1.1"
      className={className}
      style={style}
      viewBox="0 0 374.086 374.086"
      xmlSpace="preserve"
    >
      <path d="M334.044 192.042l-.143.002H182.037V39.67c-.022-5.532-4.514-10.003-10.046-10A170.98 170.98 0 0050.244 80.025C17.851 112.986 0 156.171 0 201.625c0 94.817 77.134 171.957 171.95 171.957a170.921 170.921 0 00121.721-50.355c32.393-32.962 50.232-75.939 50.232-121.393-.018-5.427-4.433-9.811-9.859-9.792zm-54.579 117.313a150.911 150.911 0 01-107.521 44.332c-83.789 0-151.956-68.219-151.956-152.008 0-40.179 15.849-78.412 44.482-107.547a150.746 150.746 0 0197.567-44.142v151.636c0 5.523 4.385 10.417 9.907 10.417h151.63a153.642 153.642 0 01-44.109 97.312z"></path>
      <path d="M323.853 50.751c-.04-.038-.081.025-.122-.016C290.769 18.343 247.537.503 202.083.503c-5.532-.003-10.024 4.468-10.046 10V172.46c0 5.522 4.57 9.583 10.093 9.583h161.956c5.425.097 9.902-4.223 9.998-9.648l.002-.144c0-45.455-17.84-88.536-50.233-121.5zM212.037 162.043V20.831c37 2.393 70.81 17.633 97.566 43.9 26.267 26.755 41.762 61.312 44.156 97.312H212.037z"></path>
    </svg>
  );
}
